import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';

const WhyDI = ({ title = null, shortDescription = null }) => {
  // JSON data embedded in the same file
    const reasonsData = [
        {
            title: 'Real-time Insights',
            description: 'Capable of gathering and delivering real-time insights with the help of a dedicated team of primary market experts with rich experience',
        },
        {
            title: 'Accurate Assessment',
            description: 'Supply high-quality primary market research outputs that meet and exceed the industry’s best practices',
        },
        {
            title: 'Unbiased Outcomes',
            description: 'Ability to provide unbiased information by triangulating insights via extensive primary research and validating via internal assessments',
        },
        {
            title: 'Social Media Tracking',
            description: 'Enable partners to tap into social media trends by monitoring the target audience with the latest and viable research technologies',
        },
        {
            title: 'Diverse PMR Services',
            description: 'Offers a collection of diverse primary market research services that can be customized and adapted as per client partners’ needs',
        },
        {
            title: 'High Turnaround',
            description: 'Facilitate cost-effective and fast turnarounds for primary market research services by acting as a global partner',
        },
    ];

    return (
        <>
            <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4 lg:mt-[230px]">
                {title && <SectionHeading title={title} shortDescription={shortDescription} />}
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="grid gap-4 grid-col-12">
                            {reasonsData.slice(0, 3).map((reason, index) => (
                                <div className="col-span-12 lg:col-span-6" key={index}>
                                    <div className="flex">
                                        <div className="bg-[#1b5df3] flex h-[30px] items-center justify-center mr-5 p-6 rounded-full text-center text-white w-[30px]">
                                            {index + 1}
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-semibold">{reason.title}</h3>
                                            <p className="text-base">{reason.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-4">
                        <Image 
                            priority={false} 
                            src={process.env.IMG_CDN+'img/primary-research/1500x1740.png'}
                            width={2000} 
                            height={2000} 
                            alt='DelveInsight' 
                            className="hidden w-full h-auto lg:block"
                        />
                    </div>
                    <div className="col-span-12 lg:col-span-4">
                        <div className="grid gap-4 grid-col-12">
                            {reasonsData.slice(3).map((reason, index) => (
                                <div className="col-span-12 lg:col-span-6" key={index}>
                                    <div className="flex">
                                        <div className="bg-[#1b5df3] flex h-[30px] items-center justify-center mr-5 p-6 rounded-full text-center text-white w-[30px]">
                                            {index + 4}
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-semibold">{reason.title}</h3>
                                            <p className="text-base">{reason.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WhyDI;